import { PropsWithChildren } from 'react';

import { Box, Text } from '@betterment/samba-react';

const Root: React.FC<PropsWithChildren> = ({ children }) => {
  return <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 'space.50' }}>{children}</Box>;
};

const LegendShape = Box;

const LegendLabel: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Text variant="text25" color="text.weak" css={{ fontSize: '10px' }}>
      {children}
    </Text>
  );
};

export const LegendItem = Object.assign(Root, { Shape: LegendShape, Label: LegendLabel });

LegendItem.displayName = 'Legend';
LegendItem.Shape.displayName = 'Legend.Shape';
LegendItem.Label.displayName = 'Legend.Label';
